exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".log-out {\n  color: #231f20 !important;\n}\n.log-out:hover {\n  color: #6f39ff !important;\n  cursor: pointer;\n}", ""]);

// exports
